export enum OwnerTypeEnum {
    User = 1,
    Charity = 2
}
